// Angular
import { Component, Input, OnInit } from '@angular/core'
// NGRX
import { select, Store } from '@ngrx/store'
// RxJS
import { Observable } from 'rxjs'
import { currentUser, Logout, User } from '../../../../../core/auth'
// State
import { AppState } from '../../../../../core/reducers'
//Services
import { StateService,ConnectionService,DialogService,TiersService } from '../../../../../services' 
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { environment } from "../../../../../../environments/environment"

import {UserProfileModifComponent} from './user-profile-info/user-profile-info.component'
import { ModifUserDialog } from '../../../content/actions/modif-user-dialog/modif-user-dialog.component';

@Component({
	selector: 'atyl-user-profile',
	templateUrl: './user-profile.component.html',
	styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
	// Public properties
	user: any;
    userDroits: any = [];
    userDroitsCodes: any = ["FORM_CONFIRM","VOIR_DOC_SUPPR", "VOIR_COURRIER_SUPPR"];
	@Input() showAvatar: boolean = true;
	@Input() showHi: boolean = true;
	@Input() showBadge: boolean = false;

	/**
	 * Component constructor
	 *
	 * @param store: Store<AppState>
	 */
	constructor(
		private store: Store<AppState>,
		private stateService: StateService,
		private conecctionService: ConnectionService,
        private dialogService: DialogService,
        private tiersService: TiersService
		) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
     ngOnInit(): void {
		this.stateService.user.subscribe((user) => {
            var userDroitTemp = null;
            if (user) {
	            if(user.droits === Object(user.droits)){
	              userDroitTemp = [user.droits];
	            }
	            else{
	                userDroitTemp = user.droits;
	            }
	            
	            this.user = user;
	            this.setUserDroits(user)
	            console.log("USER_PROFILE",this.user);
	         }   
        });
	}

    setUserDroits(user){
        this.tiersService.getTiersDroitsUser(user.id,this.userDroitsCodes).subscribe((tiersDroits: JSONRpcResponse) =>{
            if(tiersDroits.result && tiersDroits.result.tiersDroits){
                this.userDroits = tiersDroits.result.tiersDroits;
                console.log("USER_DROITS",this.userDroits);
            }
        });
    }

	/**
	 * Log out
	 */
	logout() {
		this.conecctionService.logout().subscribe(logout=>{
			console.log("logout",logout);
			environment.tokenauth='';
			environment.tokenAtyl='';
		}
		
		)
		this.stateService.resetP.next(true)
		this.store.dispatch(new Logout())
	}

    modifUser(){
        this.dialogService.open(ModifUserDialog, {
            panelClass: 'pos-relative-dialog',
            data: {
                user:this.user,
                userDroits:this.userDroits
            },
            height: "80vh",
            width: "80vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        })
    }
	
	getTypeList() {
			let types:string[]=[];
			if (this.user!=undefined && this.user.type!=undefined)
				types.push(this.user.type);
			return types;
		}
}
